import { hasClass, toggleClass, nodesToArray } from '../utils/helpers'
import { isAbove } from '../utils/breakpoints'

const toggleSelector = '.js-canvasToggle'
const dropdownSelector = '.js-dropdownToggle'
const activeClass = 'is-active'

export default class {
  constructor(el) {
    this.el = el
    this.canvasToggles = nodesToArray(document.querySelectorAll(toggleSelector))
    this.navLinks = nodesToArray(this.el.querySelectorAll('a, button'))
    this.dropdownToggles = nodesToArray(
      document.querySelectorAll(dropdownSelector),
    )

    this.canvasToggles.forEach((canvasToggle) => {
      canvasToggle.addEventListener(
        'click',
        this.onCanvasToggleClick.bind(this),
        false,
      )
    })

    this.el.addEventListener('click', function (event) {
      event.stopPropagation()
    })

    document.body.addEventListener('click', this.onClickBody.bind(this), false)

    this.dropdownToggles.forEach((dropdownToggle) => {
      dropdownToggle.addEventListener(
        'click',
        this.onDropdownClick.bind(this),
        false,
      )
      dropdownToggle.addEventListener(
        'keydown',
        this.onDropdownClick.bind(this),
        false,
      )
    })

    this.el.addEventListener('keydown', this.onCanvasKeydown.bind(this), false)

    if (isAbove('md')) {
      this.disableLinks()
    } else {
      this.enableLinks()
    }
  }

  onClickBody() {
    if (this.isActive()) {
      this.toggleCanvas(false)
    }
  }

  onCanvasToggleClick(e) {
    window.requestAnimationFrame(() => {
      this.toggleCanvas()

      if (this.isActive()) {
        this.navLinks[0].focus()
      }
    })

    e.preventDefault()
  }

  onCanvasKeydown(e) {
    if (e.key === 'Escape') {
      this.toggleCanvas(false)
    }
  }

  toggleDropdown(dropdownEl, buttonEl, newState) {
    const isActive = hasClass(dropdownEl, activeClass)
    newState = typeof newState === 'boolean' ? newState : !isActive

    toggleClass(dropdownEl, activeClass, newState)
    dropdownEl.setAttribute('aria-hidden', !newState)
    buttonEl.setAttribute('aria-expanded', newState)
  }

  onDropdownClick(e) {
    if (!e.key || e.key === 'Enter') {
      const buttonEl = e.key ? e.target : e.currentTarget
      const dropdownEl = document.getElementById(
        buttonEl.getAttribute('aria-controls'),
      )
      this.toggleDropdown(dropdownEl, buttonEl)
    }

    e.preventDefault()
  }

  /**
   * Enable links inside off-canvas
   */
  enableLinks() {
    this.navLinks.forEach((navLink) => {
      navLink.removeAttribute('tabIndex')
    })
  }

  /**
   * Disable links inside off-canvas
   */
  disableLinks() {
    this.navLinks.forEach((navLink) => {
      navLink.setAttribute('tabIndex', '-1')
    })
  }

  /**
   * Toggle off-canvas
   * @param {boolean} newState Pass true/false to open/close.
   */
  toggleCanvas(newState) {
    const isActive = this.isActive()

    newState = typeof newState === 'boolean' ? newState : !isActive

    if (newState === true) {
      this.enableLinks()
    } else {
      this.disableLinks()
    }

    toggleClass(this.el, activeClass, newState)
    this.el.setAttribute('aria-hidden', !newState)
    this.canvasToggles.forEach((canvasToggle) => {
      canvasToggle.setAttribute('aria-expanded', newState)
    })
  }

  /**
   * Check if active (e.g. target has the toggleClass set)
   */
  isActive() {
    return hasClass(this.el, activeClass)
  }
}
